"use client";

import { c as _c } from "react/compiler-runtime";
import { Link } from "@opensea/next-ui-kit";
import { FlexCenter, FlexColumn, Separator, SideSheet, SideSheetBody, SideSheetHeader, TextBody } from "@opensea/ui-kit";
import { OpenSeaBrandLogo, OpenSeaHalloweenLogo, OpenSeaLetters } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { SocialLinks } from "@/components/social/SocialLinks";
import { DISCORD_URL, INSTAGRAM_USERNAME, PRIVACY_POLICY_URL, TELEGRAM_USERNAME, TERMS_OF_SERVICE_URL, X_USERNAME } from "@/constants/constants";
import { useIsHalloweenLogoEnabled } from "@/hooks/use-flags";
import { MoreMenuActivityItem } from "./MoreMenuActivityItem";
import { MoreMenuBlogItem } from "./MoreMenuBlogItem";
import { MoreMenuCareersItem } from "./MoreMenuCareersItem";
import { MoreMenuCollectionsItem } from "./MoreMenuCollectionsItem";
import { MoreMenuConnectItem } from "./MoreMenuConnectItem";
import { MoreMenuCurrencyItem } from "./MoreMenuCurrencyItem";
import { MoreMenuDiscoverItem } from "./MoreMenuDiscoverItem";
import { MoreMenuDropsItem } from "./MoreMenuDropsItem";
import { MoreMenuFavoritesItem } from "./MoreMenuFavoritesItem";
import { MoreMenuHelpCenterItem } from "./MoreMenuHelpCenterItem";
import { MoreMenuLanguageItem } from "./MoreMenuLanguageItem";
import { MoreMenuLeaderboardItem } from "./MoreMenuLeaderboardItem";
import { MoreMenuLearnItem } from "./MoreMenuLearnItem";
import { MoreMenuOffersItem } from "./MoreMenuOffersItem";
import { MoreMenuPersonaItem } from "./MoreMenuPersonaItem";
import { MoreMenuPortfolioItem } from "./MoreMenuPortfolioItem";
import { MoreMenuProfileActivityItem } from "./MoreMenuProfileActivityItem";
import { MoreMenuProfileItem } from "./MoreMenuProfileItem";
import { MoreMenuStudioItem } from "./MoreMenuStudioItem";
import { MoreMenuSupportItem } from "./MoreMenuSupportItem";
import { MoreMenuSwapItem } from "./MoreMenuSwapItem";
import { MoreMenuThemeItem } from "./MoreMenuThemeItem";
import { MoreMenuTokensItem } from "./MoreMenuTokensItem";
import { MoreMenuTopAccount } from "./MoreMenuTopAccount";
import { MoreMenuVolumeItem } from "./MoreMenuVolumeItem";
import { MoreMenuWatchlistItem } from "./MoreMenuWatchlistItem";
const separatorClassName = "my-0.5";
export function MoreMenuSheet(t0) {
  const $ = _c(60);
  let children;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
  } else {
    children = $[1];
    rest = $[2];
  }
  const [open, setOpen] = useState(false);
  const t = useTranslations("MoreMenuSheet");
  const isHalloweenLogoEnabled = useIsHalloweenLogoEnabled();
  let t1;
  if ($[3] !== isHalloweenLogoEnabled) {
    t1 = isHalloweenLogoEnabled ? <OpenSeaHalloweenLogo size={30} /> : <OpenSeaBrandLogo size={30} />;
    $[3] = isHalloweenLogoEnabled;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <OpenSeaLetters className="translate-y-0.5" width={97} />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1) {
    t3 = <SideSheetHeader className="justify-start"><FlexCenter className="gap-2.5">{t1}{t2}</FlexCenter></SideSheetHeader>;
    $[6] = t1;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="px-2 pb-4"><MoreMenuTopAccount /></div>;
    t5 = <Separator />;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <MoreMenuDiscoverItem isSheet={true} onClick={() => {
      setOpen(false);
    }} />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <MoreMenuCollectionsItem isSheet={true} onClick={() => {
      setOpen(false);
    }} />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <MoreMenuTokensItem isSheet={true} onClick={() => {
      setOpen(false);
    }} />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <MoreMenuSwapItem isSheet={true} onClick={() => {
      setOpen(false);
    }} />;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <MoreMenuDropsItem isSheet={true} onClick={() => {
      setOpen(false);
    }} />;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <MoreMenuActivityItem isSheet={true} onClick={() => {
      setOpen(false);
    }} />;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  let t13;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <MoreMenuLeaderboardItem isSheet={true} onClick={() => {
      setOpen(false);
    }} />;
    t13 = <Separator className={separatorClassName} />;
    $[16] = t12;
    $[17] = t13;
  } else {
    t12 = $[16];
    t13 = $[17];
  }
  let t14;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <MoreMenuProfileItem isSheet={true} onClick={() => {
      setOpen(false);
    }} />;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <MoreMenuOffersItem isSheet={true} onClick={() => {
      setOpen(false);
    }} />;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <MoreMenuPortfolioItem isSheet={true} onClick={() => {
      setOpen(false);
    }} />;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <MoreMenuWatchlistItem isSheet={true} onClick={() => {
      setOpen(false);
    }} />;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <MoreMenuFavoritesItem isSheet={true} onClick={() => {
      setOpen(false);
    }} />;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  let t20;
  let t21;
  let t22;
  let t23;
  let t24;
  let t25;
  let t26;
  let t27;
  let t28;
  let t29;
  let t30;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <MoreMenuProfileActivityItem isSheet={true} onClick={() => {
      setOpen(false);
    }} />;
    t20 = <Separator className={separatorClassName} />;
    t21 = <MoreMenuPersonaItem isSheet={true} />;
    t22 = <MoreMenuThemeItem isSheet={true} />;
    t23 = <MoreMenuCurrencyItem isSheet={true} />;
    t24 = <MoreMenuVolumeItem isSheet={true} />;
    t25 = <Separator className={separatorClassName} />;
    t26 = <MoreMenuLanguageItem isSheet={true} />;
    t27 = <MoreMenuStudioItem isSheet={true} />;
    t28 = <MoreMenuLearnItem isSheet={true} />;
    t29 = <MoreMenuHelpCenterItem isSheet={true} />;
    t30 = <MoreMenuBlogItem isSheet={true} />;
    $[23] = t19;
    $[24] = t20;
    $[25] = t21;
    $[26] = t22;
    $[27] = t23;
    $[28] = t24;
    $[29] = t25;
    $[30] = t26;
    $[31] = t27;
    $[32] = t28;
    $[33] = t29;
    $[34] = t30;
  } else {
    t19 = $[23];
    t20 = $[24];
    t21 = $[25];
    t22 = $[26];
    t23 = $[27];
    t24 = $[28];
    t25 = $[29];
    t26 = $[30];
    t27 = $[31];
    t28 = $[32];
    t29 = $[33];
    t30 = $[34];
  }
  let t31;
  let t32;
  let t33;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <MoreMenuCareersItem isSheet={true} onClick={() => {
      setOpen(false);
    }} />;
    t32 = <MoreMenuSupportItem isSheet={true} />;
    t33 = <Separator className={separatorClassName} />;
    $[35] = t31;
    $[36] = t32;
    $[37] = t33;
  } else {
    t31 = $[35];
    t32 = $[36];
    t33 = $[37];
  }
  let t34;
  let t35;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <MoreMenuConnectItem isSheet={true} onClick={() => {
      setOpen(false);
    }} />;
    t35 = <Separator className={separatorClassName} />;
    $[38] = t34;
    $[39] = t35;
  } else {
    t34 = $[38];
    t35 = $[39];
  }
  let t36;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <FlexCenter className="gap-5" color="text-secondary"><SocialLinks.Discord href={DISCORD_URL} size={16} /><SocialLinks.Telegram size={16} username={TELEGRAM_USERNAME} /><SocialLinks.Twitter size={16} username={X_USERNAME} /><SocialLinks.Instagram size={16} username={INSTAGRAM_USERNAME} /></FlexCenter>;
    $[40] = t36;
  } else {
    t36 = $[40];
  }
  let t37;
  if ($[41] !== t) {
    t37 = t("privacyPolicy");
    $[41] = t;
    $[42] = t37;
  } else {
    t37 = $[42];
  }
  let t38;
  if ($[43] !== t37) {
    t38 = <Link href={PRIVACY_POLICY_URL} variant="unstyled"><TextBody>{t37}</TextBody></Link>;
    $[43] = t37;
    $[44] = t38;
  } else {
    t38 = $[44];
  }
  let t39;
  if ($[45] !== t) {
    t39 = t("termsOfService");
    $[45] = t;
    $[46] = t39;
  } else {
    t39 = $[46];
  }
  let t40;
  if ($[47] !== t39) {
    t40 = <Link href={TERMS_OF_SERVICE_URL} variant="unstyled"><TextBody>{t39}</TextBody></Link>;
    $[47] = t39;
    $[48] = t40;
  } else {
    t40 = $[48];
  }
  let t41;
  if ($[49] !== t38 || $[50] !== t40) {
    t41 = <SideSheetBody>{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}{t20}{t21}{t22}{t23}{t24}{t25}{t26}{t27}{t28}{t29}{t30}{t31}{t32}{t33}{t34}{t35}<FlexColumn className="mx-3 mt-5 mb-8 gap-5">{t36}{t38}{t40}</FlexColumn></SideSheetBody>;
    $[49] = t38;
    $[50] = t40;
    $[51] = t41;
  } else {
    t41 = $[51];
  }
  let t42;
  if ($[52] !== t3 || $[53] !== t41) {
    t42 = <>{t3}{t41}</>;
    $[52] = t3;
    $[53] = t41;
    $[54] = t42;
  } else {
    t42 = $[54];
  }
  let t43;
  if ($[55] !== children || $[56] !== open || $[57] !== rest || $[58] !== t42) {
    t43 = <SideSheet content={t42} onOpenChange={setOpen} open={open} {...rest}>{children}</SideSheet>;
    $[55] = children;
    $[56] = open;
    $[57] = rest;
    $[58] = t42;
    $[59] = t43;
  } else {
    t43 = $[59];
  }
  return t43;
}